
export class ProvisionHeader {
    ProvisionLibrary: string;
    ProvisionName: string;  
    ProvisionType: string;

    constructor(library?: string, name?: string, type?: string) {
        this.ProvisionLibrary = library;
        this.ProvisionName = name;       
        this.ProvisionType = type;
    }

    static fromApi(data: any): ProvisionHeader {
        return new ProvisionHeader(data.ProvisionOwner, data.ProvisionName, 'user_provision');
    }
}
